<script>
	
    import Canvas from "../components/Canvas.svelte";
  	import Footer from "../components/Footer.svelte";
	import Gallery from "../components/Gallery.svelte";
	import Header from "../components/Header.svelte";
    import ShortIntro from "../components/ShortIntro.svelte";
  	import ShowsList from "../components/ShowsList.svelte";
  	import ContactForm from "../components/ContactForm.svelte";
  	import AboutWork from "../components/AboutWork.svelte";
  	import DevStack from "../components/DevStack.svelte";

</script>

<main>
	
	<Canvas/>	
	<Header />
	<ShortIntro/>
	<Gallery/>
	<AboutWork/>
	<ShowsList/>
	<ContactForm/>
	<DevStack />
	<Footer/>

</main>

